import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

function makeMsalConfig(clientId: string, tenantId: string): Configuration {
    return {
        auth: {
            clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: `${window.location.origin}/redirect.html`,
        },
        cache: {
            cacheLocation: 'sessionStorage',
        },
    };
}

function maybeCreateMsalInstance(
    tenantId: string | undefined,
    clientId: string | undefined,
): PublicClientApplication | undefined {
    if (!tenantId || !clientId) {
        return undefined;
    }
    return new PublicClientApplication(makeMsalConfig(clientId, tenantId));
}

export const msalInstanceKm = maybeCreateMsalInstance(
    import.meta.env.ENTRA_KM_TENANT_ID,
    import.meta.env.ENTRA_KM_CLIENT_ID,
);

export const msalInstanceLdt = maybeCreateMsalInstance(
    import.meta.env.ENTRA_LDT_TENANT_ID,
    import.meta.env.ENTRA_LDT_CLIENT_ID,
);

export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
};
